module.exports = __webpack_public_path__ + "img/sign_230150655_1.eba5b3fb.png";